/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Summary/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Summary({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Discounts/Content/Summary"
  
}) {
let paymentPlanValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
format: fromHelpers.getValue,
})
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 color={dtColorsBlack}
 marginLeft={dtSpaceXs}
 data="payment_plan"
 format="helpers.js getValue"
 text={paymentPlanValueData}
/>
{children}
</React.Fragment>)
}